import { render, staticRenderFns } from "./ActivateCarrier.vue?vue&type=template&id=6c7d1ef6&"
import script from "./ActivateCarrier.vue?vue&type=script&lang=js&"
export * from "./ActivateCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports